import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import BundleStore from 'stores/Bundle';
import AppPage from 'components/AppPage';
import BundleActions from 'actions/Bundle';
import {
  ListItem,
  TextField,
  Dialog,
  FlatButton,
  FloatingActionButton
} from 'material-ui';
import Message from 'services/Message';
import ListDetail from 'components/Material/ListDetail';
import * as SvgIcons from 'components/Material/SvgIcons';
import { TagList, TagSelector } from 'components/Tags';
import * as Colors from 'components/Material/Styles/Colors';
import { history } from 'helpers';

const { ContentAdd } = SvgIcons;

/**
 * Creates a bundles overview, uses the next helpers
 * RefluxMixin  : Reflux helper
 * Authorizer   : Only displays this page if the user was authenticated
 * Component    : React.Component to extend
 *
 * @exports {React.Component} Bundles
 */
export default class Bundles extends mixin(RefluxMixin, Authorizer, Component) {
  state = {
    bundle: {},
    filter: {}
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  /**
   * Listen to the BundleStore and AppStore
   *
   */
  listenToStores() {
    this.listenToStore(BundleStore, 'bundle');
  }

  /**
   * Listen to actions and update state as needed
   */
  listenToActions() {
    this.listenToAction(BundleActions.removeComplete, bundle => {
      Message.info(this.context.getIntlMessage('bundle.removed'));
    });
  }

  /**
   * Read all bundles on mount
   */
  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    BundleActions.read();
  }

  /**
   * Select a particular bundle. This will result in the details of this bundle
   * to be displayed. If the current selected bundle is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} bundle Bundle to select
   */
  gotoBundle(bundle) {
    history.push(`/bundle/${bundle.id}`);
  }

  /**
   * Display a dialog for creating a new bundle
   */
  addBundleForm() {
    this.refs.createDialog.show();
  }

  deleteTag = tagName => {
    const filter = {
      ...this.statefilter
    };
    delete filter[tagName];
    this.setState({ filter });
  };

  addTag = tagName => {
    this.setState({
      filter: {
        ...this.state.filter,
        [tagName]: true
      }
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (!this.state.selected && nextState.selected) {
      history.push(`/bundle/${nextState.selected.id}`);
    }
    return true;
  }

  createListItem(item, leftAvatar, insetChildren) {
    const style = {};
    if (this.state.selected && item.id === this.state.selected.id) {
      style.backgroundColor = Colors.Colors.grey[300].material;
    }

    return (
      <ListItem
        style={style}
        leftAvatar={leftAvatar}
        insetChildren={insetChildren}
        key={'i' + item.id}
        primaryText={item.name}
        secondaryText={<TagList dense tags={item.tagsMap} />}
        onTouchTap={this.gotoBundle.bind(this, item)}
      />
    );
  }

  addTag(e, tagName) {
    if (e) {
      tagName = this.refs.addTag.getValue();
    }
    let { filter } = this.state;
    filter[tagName] = true;
    this.setState({ filter });
    this.refs.addTag.clearValue();
  }

  /**
   * Confirms the creation of a bundle and invokes the proper action
   * @return {[type]} [description]
   */
  onConfirmCreate() {
    BundleActions.create({ name: this.refs.bundleName.getValue() });
    this.refs.createDialog.dismiss();
  }

  /**
   * Renders the bundles: Basically a ListDetail element with a detail element
   * if there was one selected
   *
   * @return {React.Element} Created render element
   */
  render() {
    let bundles = this.state.bundle.list;
    let detail;
    let standardActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('Create')}
        secondary={true}
        className="full"
        onTouchTap={this.onConfirmCreate.bind(this)}
      />
    ];

    let filterFunc = (item, searchText, labelProperty) => {
      let hasTags = true;
      Object.keys(this.state.filter).forEach(tagName => {
        let tagsMap = item.tagsMap || {};
        hasTags = hasTags && tagsMap[tagName];
      });
      if (!hasTags) {
        return false;
      }
      if (searchText && searchText !== '') {
        return item[labelProperty].search(searchText) > -1;
      } else {
        return true;
      }
    };

    const tagSelector = (
      <TagSelector
        onAddTag={this.addTag}
        onRemoveTag={this.deleteTag}
        tags={this.state.filter}
        fullWidth
        padded
      />
    );

    return (
      <AppPage
        header={
          <RulerBar title={this.context.getIntlMessage('menu.Bundles')} />
        }
      >
        <ListDetail
          items={bundles}
          labelProperty="name"
          hasDivider={false}
          filter={filterFunc}
          listHeader={tagSelector}
          listItemGenerator={this.createListItem.bind(this)}
          floatingActionButton={
            <FloatingActionButton onTouchTap={this.addBundleForm.bind(this)}>
              <ContentAdd />
            </FloatingActionButton>
          }
        >
          {this.props.children}
        </ListDetail>
        <Dialog
          ref="createDialog"
          title={this.context.getIntlMessage('bundle.new')}
          actions={standardActions}
          dismissOnClickAway={true}
        >
          <TextField
            ref="bundleName"
            fullWidth={true}
            hintText={this.context.getIntlMessage('bundle.name')}
            floatingLabelText={this.context.getIntlMessage('bundle.name')}
          />
        </Dialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Bundles.js